<span class="position-relative">
  @if (noUnseen() === false) {
    <span class="my-notifications-indicator">
      <span class="visually-hidden">{{ 'myNotifications.unseenNotifications' | translate }}</span>
    </span>
  }

  <portal-dropdown-menu
    [arrow]="true"
    [distance]="15"
    icon="far fa-bell"
    theme="my-notifications-dropdown"
    tooltip="myNotifications.title"
  >
    <portal-errors [errors]="state.error()"></portal-errors>

    <portal-icon-button
      class="my-notification__head-action"
      [disabled]="viewModel()?.anyUnseen === false"
      [loading]="state.busy()"
      [portalTippy]="'myNotifications.markAllAsSeen' | translate"
      [preventAndStop]="true"
      (onClick)="markAllAsSeen()"
      appendTo="body"
      iconClass="far fa-check-double"
    ></portal-icon-button>

    <!-- Empty -->
    @if (noUnseen()) {
      <div class="notification-item notification-item--empty g-cursor-default">
        <img alt="Empty clipboards" height="100" ngSrc="assets/images/no-data.svg" width="96" />

        <span>{{ 'myNotifications.none' | translate }}</span>
      </div>
    }

    <div class="my-notifications" role="list">
      <!-- General items -->
      @if (generalItems().length > 0) {
        <p class="my-notifications__header" role="heading">{{ 'myNotifications.general' | translate }}</p>
      }

      @for (notification of generalItems(); track notification.name) {
        <portal-my-notifications-dropdown-item
          [notification]="notification"
          role="listitem"
        ></portal-my-notifications-dropdown-item>
      }
    </div>

    <div class="dropdown-divider mt-1 mb-0"></div>

    <button class="text-center" (click)="showAllNotifications()" portalDropdownItem>
      <span>{{ 'myNotifications.showAll' | translate }}</span>
    </button>
  </portal-dropdown-menu>
</span>
